export class PostalCode {
    id!: string;
    postalCode!: string;
    city!: string;
  }
  